<template>
<div id="store-deletion-modal" class="modal modal-right fade" data-backdrop="static" role="dialog">
    <!-- <div> -->
    <div class="modal-dialog modal-xl" role="document">
        <div ref="section" class="modal-content">
            <div class="modal-header bg-dark">
                <h5 class="modal-title">{{ $t('Store Deletion') }}</h5>
                <button type="button" class="close" @click="closeModal()" ref="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            
            <div v-if="!isLoadData">
                <div class="modal-body pt-0 pb-5">
                    <StoreSummaryLists v-if="isSummaryLists" />
                    <Verification v-if="isVerification" />
                    <VerificationCode v-if="isVerificationCode" ref="code" />
                </div>
                <div class="modal-footer modal-footer-fixed bg-light py-2 border-bottom justify-content-center">
                    <template v-if="isSummaryLists">
                        <button @click="showVerificationOption()" :disabled="!isAgree" type="button" class="btn btn-primary mr-2">
                            <i class="fa-solid fa-circle-arrow-right mr-1"></i>{{ $t("Next") }}
                        </button>
                        <button @click="closeModal()" type="button" class="btn btn-light">
                            {{ $t("Cancel") }}
                        </button>
                    </template>
                    <template v-if="isVerification">
                        <button @click="showVerificationCodeForm()" :disabled="!verifyMethodId" type="button" class="btn btn-primary mr-2" :class="[loading ? 'disabled' : '']">
                            <i :class="[loading ? 'icon-spinner2 spinner' : 'fa-solid fa-paper-plane','mr-1',]"></i>{{ $t("Send code") }}
                        </button>
                        <button @click="showSummaryLists()" type="button" class="btn btn-light">
                            {{ $t("Back") }}
                        </button>
                    </template>
                    <template v-if="isVerificationCode">
                        <ladda text="Confirm"
                            :btnClass="'btn btn-primary mr-2'" 
                            :loading="isSubmit"
                            :disabled="isDisabled"
                            icon="<i class='fa-regular fa-circle-check mr-1'></i>"
                            @click="confirmCode()"
                        >
                        </ladda>

                        <!-- <button @click="confirmCode()" type="button" class="btn btn-primary mr-2">
                            <i class="fa-regular fa-circle-check mr-1"></i>{{ $t("Confirm") }}
                        </button> -->
                        <button @click="showVerificationOption()" type="button" class="btn btn-light">
                            {{ $t("Back") }}
                        </button>
                    </template>

                </div>
            </div>

            <div class="modal-body" v-else>
                <placeholder-content isLoad='true'></placeholder-content>
            </div>

        </div>
    </div>
</div>
</template>

<script>
import StoreSummaryLists from "./StoreSummaryLists";
import Verification from "./Verification";
import VerificationCode from "./VerificationCode";
import CentralApi from '@/services/endpoint/central.service'
import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
import Ladda from '@/plugins/Ladda.vue'


export default {
    name: "ModalDeleteStore",
    components: {
        StoreSummaryLists,
        Verification,
        VerificationCode,
        PlaceholderContent,
        Ladda,
    },
    data() {
        return {
            isLoadData: true,
            isSummaryLists: true,
            isVerification: false,
            isVerificationCode: false,
            tenantID : this.$parent.storeId,
            owner:{
                'firstName' : this.$parent.userFirstName,
                'lastName' : this.$parent.userLastName,
                'telephone' : this.$parent.mobileUser,
                'email' : this.$parent.emailUser,
            },
            isAgree: false,
            isSubmit: false,
            isDisabled: false,
            storeData: {
                summaryCard: {
                    'Orders': 0,
                    'Products': 0,
                    'Customers': 0,
                    'Users': 0,
                },
                storeName: '',
                email: '',
                phone: '',
                service: '',
                storeIndustry: '',
                currentPlan: '',
                apps: '',
                createdDate: '',
                shippingCredit: 0,
                sms: 0,
            },
            verificationCode: '',
            refCodeId: '',
            verifyMethodId: null,
            loading:false
        };

    },
    methods: {
        
        closeModal() {
            this.$refs.close.click();
            this.$parent.isDelete = false;
        },
        showSummaryLists() {
            this.isSummaryLists = true;
            this.isVerification = false;
            this.isVerificationCode = false;
        },
        showVerificationOption() {
            this.isSummaryLists = false;
            this.isVerification = true;
            this.isVerificationCode = false;
        },
        async showVerificationCodeForm() {
            this.addLoading(true);
            if (this.verifyMethodId == 1) {
                let allow = await CentralApi.Auth.iswhitelistEmail(this.centralUser.email);
                if(!allow.data.whitelist){
                    let notAllowed = await CentralApi.Auth.isblacklistEmail(this.centralUser.email);
                    if(notAllowed.data.blacklist){
                        this.addLoading(false);
                        this.$toastr.Add({
                            type: "warning",
                            title: "<span class='icon-warning22 mr-2'></span>"+this.$t('Something went wrong.'),
                            msg: this.$t("Email cannot be sent to")+" "+
                                 this.centralUser.email+" "+
                                 this.$t("because this recipient is in blacklist.")+" "+
                                 this.$t("If you feel this is a mistake, contact your admin."),
                            clickClose: true,
                            timeout: 5000,
                            position: "toast-top-right"
                        });
                        return false;
                    }
                }
                let data = {
                    'firstName' : this.centralUser.first_name,
                    'lastName' : this.centralUser.last_name,
                    'email' : this.centralUser.email,
                    'storeName' : this.storeData.storeName,
                };
                try {
                    let sendVerify = await CentralApi.Tenant.sendVerify(this.tenantID, data);
                    this.verificationCode = sendVerify.data.randomNumber;
                    this.refCodeId = sendVerify.data.refcode;
                    this.isSummaryLists = false;
                    this.isVerification = false;
                    this.isVerificationCode = true;
                    this.addLoading(false);
                    return true;
                } catch (error) {
                    this.addLoading(false);
                    let message = error.response.data.message;
                    if(message == "This email is blacklisted.") {
                        message = this.$t("Email cannot be sent to")+" "+
                                this.centralUser.email+" "+
                                this.$t("because this recipient is in blacklist.")+" "+
                                this.$t("If you feel this is a mistake, contact your admin.");
                    }
                    this.$toastr.Add({
                        type: "warning",
                        title: "<span class='icon-warning22 mr-2'></span>"+this.$t('Something went wrong.'),
                        msg: message,
                        clickClose: true,
                        timeout: 5000,
                        position: "toast-top-right"
                    });
                    return false;
                }
            } else if (this.verifyMethodId == 2) {
                let data = {
                    'telephone' : this.centralUser.mobile,
                    'message' : 'รหัส OTP : {OTP} กรุณายืนยันตัวตนบน ' + this.storeData.currentPlan + ' ภายใน 1 นาที',
                };
                let sendVerify = await CentralApi.Tenant.sendVerifySMS(this.tenantID, data);
                this.verificationCode = sendVerify.data.randomNumber;
                this.refCodeId = sendVerify.data.refcode;
                this.isSummaryLists = false;
                this.isVerification = false;
                this.isVerificationCode = true;
                this.addLoading(false);
            }
        },
        addLoading(status) {
            this.loading = status;
        },
        async confirmCode() {
            this.isSubmit = true;
            this.isDisabled = true;
            await this.$refs.code.handleVerficationCode();
            
        },
        async getStoreDetail(){
            this.isLoadData = true;
            console.log(this.tenantID,'this.tenantID');
            let getStoreDetail = await CentralApi.Tenant.getStoreDetail(this.tenantID);
            let storeDetail = getStoreDetail.data;
            
            // total
            this.storeData.summaryCard.Orders = storeDetail.total.orders;
            this.storeData.summaryCard.Products = storeDetail.total.products;
            this.storeData.summaryCard.Customers = storeDetail.total.customers;
            this.storeData.summaryCard.Users = storeDetail.total.users;

            // centralTenant
            this.storeData.storeName = storeDetail.centralTenant.setting.name;
            this.storeData.email = storeDetail.centralTenant.setting_tenant ? storeDetail.centralTenant.setting_tenant.email_contact : '';
            this.storeData.phone = storeDetail.centralTenant.setting_tenant ? storeDetail.centralTenant.setting_tenant.phone : '';
            this.storeData.createdDate = storeDetail.centralTenant.created_at;

            // industry
            this.storeData.storeIndustry = storeDetail.industry.name;

            // walletBalanceALL
            this.storeData.shippingCredit = storeDetail.walletBalanceALL.data.shipment.balance;
            this.storeData.sms = storeDetail.walletBalanceALL.data.sms.balance;
            
            // plans
            this.storeData.service = storeDetail.centralTenant.plans.name;
            this.storeData.currentPlan = storeDetail.centralTenant.plans.name;
            this.storeData.apps = storeDetail.centralTenant.plans.name;

            this.isLoadData = false;

        },
    },
    computed: {
		centralUser() {
			return this.$store.state.central.centralUser.data.data;
		}
	},
    async mounted() {
        await this.getStoreDetail();
    },
}
</script>



// WEBPACK FOOTER //
// src/components/central/account/stores/ModalDeleteStore.vue